import { config } from "config";
import format from "date-fns/format";
import { change, reset } from "redux-form";
import { QuotationFiltersProps, fields } from ".";
import MyForm from "components/templates/MyForm";
import { quotationActions } from "redux/slices/quotation";
import { MODAL, modalActions } from "redux/slices/modal";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import PersistFilters from "components/templates/PersistFilters";

export default function QuotationFilters({ type,query,handleResetquery }: QuotationFiltersProps) {
	const form = "QuotationFiltersForm";
	const dispatch = useAppDispatch();

	const onClickReset = () => {
		const default_page_size = config.PAGE_SIZE;
		dispatch(quotationActions.resetFilters(type));
		dispatch(reset(form));
		dispatch(change(form, "page_size", default_page_size));
		handleResetquery()
	};

	const handleSubmit = (values: any) => {
		const default_page_size = config.PAGE_SIZE;
		let data: any = { page: 1, page_size: default_page_size };
		const {
			date,
			quotation_id,
			company_name,
			company_email,
			page_size,
		} = values;
		if (quotation_id) data.quotation_id = quotation_id;
		if (company_name) data.company_name = company_name;
		if (company_email) data.company_email = company_email;
		if (page_size) data.page_size = Number(page_size);
		if (date && date.date[0] && date.date[1]) {
			data.end_date = format(new Date(date.date[1]), "yyyy-MM-dd");
			data.start_date = format(new Date(date.date[0]), "yyyy-MM-dd");
		}

		dispatch(quotationActions.setFilters({ data, type }));
	};

	return (
		<div className="filters">
			<MyForm
				form={form}
				myFields={fields}
				onSubmit={handleSubmit}
				onClickReset={onClickReset}
				// onClickExport={onClickExport}
			/>
			<PersistFilters form={form} type={type} />
		</div>
	);
}
